var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.595 6.77L13.37.996a.583.583 0 1 0-.825-.825L6.771 5.945.996.171A.583.583 0 0 0 .17.996L5.946 6.77.17 12.544a.583.583 0 1 0 .825.825L6.77 7.595l5.774 5.774a.583.583 0 0 0 .825-.825L7.595 6.77z", fillRule: "nonzero" })
  );
});